import './vehicles.scss';
import Header from '../../../organisms/header/header.js';
import RoleRibbonByRole from '../../../organisms/common/role-ribbon/role-ribbon-by-role';
import React, { useEffect, useState } from 'react';
import {Link, Navigate, useLocation, useNavigate} from 'react-router-dom';
import OrgVehicles from '../../../organisms/common/hac-vehicles/org-vehicles';
import { useTranslation } from 'react-i18next';
import decodeToken from '../../../../utils/decode-token';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import HacNavigation from "../../../organisms/common/hac-navigation/hac-navigation";
import { canAccessHacManagement, getHacBackPathForRole } from '../../../../utils/role-utils';

function VehiclesList() {
  const { t } = useTranslation();

  const token = sessionStorage.getItem('token') || '';
  const role = decodeToken(token).role;
  const navigate = useNavigate();
  const location = useLocation();
  const {breadcrumbName, backPath} = location.state || {};
  const [openSnackbar, setOpenSnackbar] = useState(false);

  useEffect(() => {
    if (location.state?.openSnackbar) {
      setOpenSnackbar(true);
    }
  }, [location.state]);

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  return (
    <>
      {token && canAccessHacManagement(role) ? (
        <div className="App">
          <Header />
          <RoleRibbonByRole role={role} navigate={navigate} translate={t} />
          <main>
            <section
              className={`${canAccessHacManagement(role) ? 'no-bg' : ''}`}>
              <div
                className="inner menu">
                <HacNavigation />
                <main>
                  <Link
                    to={backPath || getHacBackPathForRole(role)}
                    className="back-button"
                  >
                    <span className="icon-chevron-left"></span> {t('common-back')}{' '}
                    / {breadcrumbName}{' '}
                  </Link>

                  <h4>{t('hac-my-profile-vehicles-title')}</h4>
                  <p>{t('hac-my-profile-vehicles-text')}</p>
                  <OrgVehicles breadcrumbName={breadcrumbName} />
                </main>
                <Snackbar
                  open={openSnackbar}
                  autoHideDuration={6000}
                  onClose={handleSnackbarClose}
                >
                  <Alert
                    onClose={handleSnackbarClose}
                    severity="success"
                    sx={{ width: '100%' }}
                  >
                    {t('alert-data-saved')}
                  </Alert>
                </Snackbar>
              </div>
            </section>
          </main>
        </div>
      ) : (
        <Navigate to="/login" />
      )}
    </>
  );
}

export default VehiclesList;
